import React from 'react';
import StatusBadge from './StatusBadge';
import { cellText } from './columns';
import useNames from '../../hooks/useNames';
import s from './students.module.css';

// One row of the students table. Which columns are on is decided above; this
// renders the ones it is given.

export default function StudentRow({ student, columns, ticked, onTick, onOpen, cellContext }) {
  const names = useNames();
  return (
    <tr>
      <td className={s.tickCell}>
        <input
          type="checkbox"
          checked={ticked}
          aria-label={`Select ${names.student(student)}`}
          onChange={() => onTick(student.id)}
        />
      </td>
      {columns.map((c) => (
        <td key={c.id}>
          {c.id === 'student' ? (
            <>
              <button className={s.name} onClick={() => onOpen(student.id)}>
                {names.student(student)}
              </button>
              <StatusBadge status={student.status} />
            </>
          ) : cellText(student, c.id, cellContext)}
        </td>
      ))}
    </tr>
  );
}
